<template>
	<div class="overflowxHidden">

		<div class="page-back-btn" v-if="!$route.query.hotelId" onclick="window.history.go(-1)">
            <i class="iconfont icon-yuyin"></i>

       	</div>
	   	<div class="page-back-btn" v-if="$route.query.hotelId" @click="$router.push('/')">
            <i class="iconfont icon-yuyin"></i>

       	</div>

	    <div class="lmy-product-detail" >

			<div class="banner" v-if="details" >
				<Swipe class="index-cal" style="height:200px;" v-if="details.Pics&&details.Pics.length>0">
					<SwipeItem  v-for="img in details.Pics" :key="img.Url" >
						<img :src="img.Url | replaceImgSrc(4)" :alt="img.Name" style="width:100%;height:200px"  />
					</SwipeItem>
			
				</Swipe>
				<Swipe class="index-cal" style="height:200px;"  v-if="!details.Pics||details.Pics.length<=0">
				
					<SwipeItem>
						<img src="./../../assets/img/hotelDetailsDf.png" style="width:100%;height:200px"/>
					</SwipeItem>
				</Swipe>
	            <div class="banner-btm">
					
	                <div class="collect">
	                	<i class="iconfont icon-shoucang1" v-if="!isHotelCorrect"  @click="saveHotel(details)"></i>
	                	<i class="iconfont icon-shoucang"  v-if="isHotelCorrect" @click="unsaveHotel(details)"></i>
	                </div>
	            </div>
	        </div>

			<div class="hotel-intro">
				<div class="topic" v-if="details">
					<div class="hotel-title">
						{{details.HotelName||''}}
						<span class="type" v-if="details.Star<=3">经济型</span>
						<span class="type" v-if="details.Star>3 && details.Star<=5">舒适型</span>
						<span class="type" v-if="details.Star>5 && details.Star<=7">高档型</span>
						<span class="type" v-if="details.Star>7">豪华型</span>
					</div>
	                <div class="hotel-ename">{{details.HotelEName||''}}</div>
	                <p class="facility-year">{{'酒店电话：'+details.Phone}}</p>

					<span class="right-bar" @click="routeToReadme">详情/设施<i class="iconfont icon-more"></i></span>
				</div>


				<div class="address" v-if="details">
					<span class="right-bar" @click="routeToMap(details)">地图/周边<i class="iconfont icon-more"></i></span>
					<p>{{details.Address}} <span class="region" v-if="details.DistrictName||details.Landmark">{{details.DistrictName||''}}</span></p>
					<p class="region" v-if="details.Landmark">{{details.Landmark||''}}</p>
	            	<p class="region">	{{details.LocationCN}}</p>
					<p class="detail-address" v-if="details.SubwayInfo">{{details.SubwayInfo||''}}</p>
					<p class="detail-address" v-if="details.Distance">{{details.Distance||''}}</p>
				</div>

				<div class="grade" v-if="details">
					<span class="score">{{details.CommRate}}</span>
					<div class="grade-detail" >
						<p class="score-total" v-if="details.Evaluation||details.CommRate">{{details.Evaluation}} 综合评分{{details.CommRate}}/5分</p>
						<p class="score-detail">
							<span v-if="details.SurroundRate">位置 {{details.SurroundRate}}</span>
							<span v-if="details.FacilityRate">设施 {{details.FacilityRate}}</span>
							<span v-if="details.ServiceRate">服务 {{details.ServiceRate}}</span>
							<span v-if="details.CleanRate">卫生 {{details.CleanRate}}</span>
						</p>
					</div>
				</div>
	        </div>
			
	        <!-- <div class="address" v-if="details">
	            <span class="right-bar" @click="routeToMap(details)">地图/周边<i class="iconfont icon-more"></i></span>
	            <p>{{details.Address}} 
	            <span class="ps" v-if="details.DistrictName||details.Landmark">【 {{details.DistrictName||''}}  {{details.Landmark||''}} 】</span></p>
	            <p>	{{details.LocationCN}}</p>
	            <p class="detail-address" v-if="details.SubwayInfo"><span class="detail-icon"><i class="iconfont icon-lmy-ditie"></i></span>{{details.SubwayInfo||''}}</p>
	           
	            <p class="detail-address" v-if="details.Distance"><span class="detail-icon"><i class="iconfont icon-lmy-dingwei"></i></span>{{details.Distance||''}}</p>
	        </div> -->


	        <!-- <div class="grade" v-if="details">
		        <div class="grade-percent">
		            <canvas id="canvas"></canvas>
		            <span id="score">{{details.CommRate}}</span>
		        </div>
	            <div class="grade-detail" >
	                <p class="score-total" v-if="details.Evaluation||details.CommRate"><span>{{details.Evaluation}}</span>综合评分{{details.CommRate}}/5分</p>
	                <p class="score-detail">
	                    <span v-if="details.SurroundRate">位置 {{details.SurroundRate}}</span>
	                    <span v-if="details.FacilityRate">设施 {{details.FacilityRate}}</span>
	                    <span v-if="details.ServiceRate">服务 {{details.ServiceRate}}</span>
	                    <span v-if="details.CleanRate">卫生 {{details.CleanRate}}</span>
	                </p>
	            </div>
	        </div>  -->
			<div class="select-bar" v-if="details" >
				<div class="select-item">
					<div class="select-date" @click="openDatePicker">
						{{CheckIn|dateShort}}
						<span class="day">{{getDays(CheckIn,CheckOut)}}晚</span>
						{{CheckOut|dateShort}}
					</div>
					
					<div class="line"></div>
					<div class="select-people-info"  @click="openRoomMange">
						<span>成人{{AdultCount}}</span><br>
						<span>儿童{{ChildrenCount||0}}</span>
					</div>
					<div class="line"></div>
					<div class="select-people"  @click="openRoomMange">
						{{RoomCount}}间 	
					</div>
				</div>

	        </div> 

	        <!-- <div class="facility" v-if="details" > -->
	            <!-- 国内-->
	            <!-- <div class="facility-content inland">
	                <span class="right-bar" @click="routeToReadme">详情/设施<i class="iconfont icon-more"></i></span>
	                <p class="facility-year">{{'酒店电话：'+details.Phone}}</p>
	                <p class="facility-label" >
	                	<label v-for="eqmt in details.Facilities" >
	                		<i :class="'iconfont  icon-f-'+eqmt"></i>{{eqmtList[eqmt]}}
	                	</label>
	                </p>
	            </div> -->
	            <!-- <div class="hotel-info" :style="isSellingPointShow?'height:auto':''" v-if="details.SellingPoint">
	            	<i :class="isSellingPointShow?'iconfont icon-xiala active':'iconfont icon-xiala'" @click="isSellingPointShow=!isSellingPointShow"></i>
		            {{details.SellingPoint}}
		        </div> -->
	        <!-- </div> -->

	        <!-- 海外-->
	        <!-- <div class="overseas" v-if="details">
	        	<div class="select-item">
	            	<span class="select-icon"><i class="iconfont icon-calendar"></i></span>
	            	<span class="select-date" @click="openDatePicker">{{CheckIn|dateShort}} - {{CheckOut|dateShort}} <span>共{{getDays(CheckIn,CheckOut)}}晚</span> <i class="iconfont icon-more"></i></span>
	            </div>
	            <div class="select-item">
	            	<div class="select-people" @click="openRoomMange">
						<div class="select-people-icon">
							<i class="iconfont icon-yqfjianshu"></i>
						</div>
						<div class="select-people-info">
							<span>成人{{AdultCount}}</span>
							<span>儿童{{ChildrenCount||0}}</span>
						</div>
						<div class="select-people-total">
							{{RoomCount}}间 <i class="iconfont icon-more"></i>
						</div>
	            	</div>
	            </div>
	        </div> -->

	        <!-- 房间列表 -->
	        <div class="room-list"  v-for="(room ,$index) in detailsRooms" @click="book(room,$event)"  v-show="$index<listShowLenght&&!isLoading">
	            <div class="list-item fr-hotel-box">
	            	<div class="fr-info-box">
	            		<h5 class="title">{{room.RoomName}}</h5>
		                <p class="info">
		                	{{(room.RoomSize?(room.RoomSize+'㎡'):'')}}
		                	{{room.Floor?(room.Floor+'层 '):''}}
							<label v-if="room.Window==0">部分有窗</label>
							<label v-if="room.Window==1">有窗</label>
							<label v-if="room.Window==2">无窗</label>
							<label v-if="room.Net==0">无网络</label>
							<label v-if="room.Net==1">宽带</label>
							<label v-if="room.Net==2">WIFI</label>
		                </p>
						<p class="info"><label>{{room.RPName||""}}</label></p>
		                <p class="info"> <label>{{room.CancelPolicy||''}}</label></p>
		                    <!-- 返佣对全部人开放 -->
		                <!-- <div class="hotel-Rebate-price " v-if="room.Rebate">
		                	返佣¥{{room.Rebate}}
		                </div> -->
	            	</div>
	                <div class="fr-book-box">
	                	<div>
	                		<div class="fr-price" v-if="room.AvgPrice">均¥<span>{{room.AvgPrice|numberFloatDel}}</span></div>
	                		<div class="fr-price" v-if="!room.AvgPrice">暂无价格</div>
	                		<p class="fr-status" v-if="room.Stock>=5&&room.Tip!=6">房量充足</p>
	                		<p class="fr-status" v-if="room.Stock<5&&room.Stock>0&&room.Tip!=6">
								仅剩<span>{{room.Stock}}</span>间
	                		</p>
	                	</div>
	                	<div>
	                		<div :class="room.Tip==1||room.Tip==0?'fr-res-btn':'fr-res-btn disabled'">预订</div>
	                		<div class="fr-res-type" v-if="room.Tip==0">立即确认</div>
							<div class="fr-res-type fr-res-type-long"  v-if="room.Tip==1&&dateToday==CheckIn" >0.5小时内确认</div>
							<div class="fr-res-type "     v-if="room.Tip==1&&dateToday!=CheckIn" >1小时内确认</div>
							<div class="fr-res-type not"  v-if="room.Tip==3">需提前</div>
							<div class="fr-res-type not"  v-if="room.Tip==4">需连住</div>
							<div class="fr-res-type"      v-if="room.Tip==5">{{room.MiniRoomCount}}间以上</div>
							<div class="fr-res-type not"  v-if="room.Tip==6">售罄</div>
	                	</div>
	                </div>
	            
	            </div>
	     
	        </div>

			<div class="infinite-loading-containers" v-if="isLoading">
				<i class="loading-defaults"></i>
			</div>
			<ul class="home-holte-bottom">
				<li @click="listShowLenght=detailsRooms.length" v-if="!isLoading&&detailsRooms&&detailsRooms.length>5&&listShowLenght==5">查看全部 <i class="iconfont icon-more" ></i></li>
				<li @click="listShowLenght=5" v-if="details.Rooms&&details.Rooms.length>5&&listShowLenght>5">收起 <i class="iconfont icon-more" ></i></li>
			</ul>
	        <div class="text-center" v-if="!isLoading&&(!detailsRooms||detailsRooms.length<=0)">
				酒店客房已售完
	        </div>

	        <!-- <div class="no-more" v-if="details">
	            <hr>
	            <span>亲，我们是有底线的</span>
	        </div> -->
	    </div>
		<transition  name="slide" >
			<DatePicker @select="calendar.select" :start="calendar.start" :beginDate="calendar.begin" :endDate="calendar.end" :monthLength="calendar.monthLength"  v-show="calendar.show" ></DatePicker>
		</transition>
		<roomAndPerson @select="rpData.select" v-show="rpData.show" :rpData="rpData" ></roomAndPerson>
	    
		<cnAlert ref="cnAlert"></cnAlert>
	</div>
</template>
<script>
	// ps:From===1为国内酒店，From==0为国外酒店
	import DatePicker from './../common/cmpnt/datePicker/datePicker.vue'//日期选择器
	import eqmtList from './../common/equitment.js'
	import roomAndPerson from './../common/cmpnt/roomAndPerson.vue'//酒店房间和入住人数
	import cnAlert from './../common/cmpnt/cnAlert.vue'
	require('vue-swipe/dist/vue-swipe.css');
	const { Swipe, SwipeItem } = require('vue-swipe');//轮播图
	export default{
		name:'hotelDetails',
		components:{
			cnAlert,
			Swipe,
		    SwipeItem,
			DatePicker,
			roomAndPerson,
		},
		data(){
			return{
				HotelID:this.$route.query.hotelId||JSON.parse(this.dao.get('frHotelDetailsParams')).HotelID,
				ProductType:0,
				From:0,
				dateToday:this.getDate(0),
				CheckIn:this.$route.query.CheckIn||JSON.parse(this.dao.get('frHotelDetailsParams')).CheckIn,
				CheckOut:this.$route.query.CheckOut||JSON.parse(this.dao.get('frHotelDetailsParams')).CheckOut,
				// ShareToken:this.$route.query.share||JSON.parse(this.dao.get('frHotelDetailsParams')).ShareToken,
				RoomCount:this.dao.get('frHotelDetailsParams')?JSON.parse(this.dao.get('frHotelDetailsParams')).RoomCount:1,
				AdultCount:this.dao.get('frHotelDetailsParams')?JSON.parse(this.dao.get('frHotelDetailsParams')).AdultCount:2,
				ChildrenCount:this.dao.get('frHotelDetailsParams')?JSON.parse(this.dao.get('frHotelDetailsParams')).ChildrenCount:0,
				MyLat:this.dao.get('hotelListSearchParams')?JSON.parse(this.dao.get('hotelListSearchParams')).MyLat:'',
				MyLon:this.dao.get('hotelListSearchParams')?JSON.parse(this.dao.get('hotelListSearchParams')).MyLon:'',
				eqmtList:eqmtList,
				ChildrenAges:this.dao.get('frHotelDetailsParams')?JSON.parse(this.dao.get('frHotelDetailsParams')).ChildrenAges:'',
				isLoading:false,
				isIntruduceOpen:false,
				isHotelCorrect:false,
				isSellingPointShow:false,
			
				calendar:{
	                monthLength:6,
	                show:false,
	                start:{year:this.getDate(0).split('-')[0],month:this.getDate(0).split('-')[1],day:this.getDate(0).split('-')[2]},
	 				begin:{year:this.getDate(1).split('-')[0],month:this.getDate(1).split('-')[1],day:this.getDate(1).split('-')[2]},
	                end:  {year:this.getDate(2).split('-')[0],month:this.getDate(2).split('-')[1],day:this.getDate(2).split('-')[2]},
	                select:(begin,end)=>{
	                	this.calendar.show=false;
	                    if(!begin||!end){
	                        this.calendar.show=false;
	                        return;
	                    }
	                    this.calendar.begin=begin;
	                    this.calendar.end=end;
	                    this.CheckIn=begin.year+'-'+begin.month+'-'+begin.day;
	                    this.CheckOut=end.year+'-'+end.month+'-'+end.day;
	                    this.initData();
	                    
	                }
	            },
	      
	            roomCountData:{
					show:false,
					select:(count)=>{
						this.roomCountData.show=false;
						this.RoomCount=count;
						this.initData();
					}
				},
				rpData:{
                    show:false,
                    RoomCount:this.dao.get('frHotelDetailsParams')?JSON.parse(this.dao.get('frHotelDetailsParams')).RoomCount:1,
                    AdultCount:this.dao.get('frHotelDetailsParams')?JSON.parse(this.dao.get('frHotelDetailsParams')).AdultCount:2,
                    ChildrenCount:this.dao.get('frHotelDetailsParams')?JSON.parse(this.dao.get('frHotelDetailsParams')).ChildrenCount:0,
                    ChildrenAges:this.dao.get('frHotelDetailsParams')?JSON.parse(this.dao.get('frHotelDetailsParams')).ChildrenAges:'',
                    from:0,
                    select:(val,age)=>{
                        this.rpData.show=false;
                        this.RoomCount=val.RoomCount;
                        this.AdultCount=val.AdultCount;
                        this.ChildrenCount=val.ChildrenCount;
                       
                        var ageList=[];
                        age.forEach((item,index)=>{
                            ageList.push(item.ChildrenAges);
                        })
                        this.ChildrenAges=ageList;
                        this.initData();

                    }
                },
				details:'',
				detailsRooms:'',
				listShowLenght:5//显示房价个数，默认2个
			}
		},
		methods:{
			openRoomMange(){
				if(this.isLoading){
					this.error({title:'提示',content:'请等待查询结果'});
					return;
				}
				this.rpData.show=true
			},
			openDatePicker(){
				if(this.isLoading){
					this.error({title:'提示',content:'请等待查询结果'});
					return;
				}
				this.calendar.show=true
			},

			initData(isGetPrice){
				var that=this;

				var params={
					HotelID:this.HotelID,
					ProductType:0,
					From:this.From,
					CheckIn:this.CheckIn,
					CheckOut:this.CheckOut,
					RoomCount:this.RoomCount,
					AdultCount:this.AdultCount,
					ChildrenCount:this.ChildrenCount,
					GetPrice:isGetPrice?true:false,
					ChildrenAges:this.ChildrenAges,
					// ShareToken:'',
				}
				if(this.isLoading){
					that.error({title:'提示',content:'请等待查询结果'});
					return;
				}
				this.isLoading=true;
				that.postRequest({
		            url: that.Api.hotel,
		            params: params
		        }).then(res => {
		        	this.isLoading=false;
					if (res&&res.IsSuccess) {
						if(!isGetPrice){
							var option=res.Result.ShareInfo;
					    	that.setConfigShare(option);
					    	that.details=res.Result;
						    // that.$nextTick(function () {
							// 	 that.initCanvas();
							// })
							that.initData(true)
						}else{
							that.detailsRooms=res.Result.Rooms
						}
				    } else {
			            that.details=''
			        }
		        });
			},
			//取消收藏酒店
			unsaveHotel(hotel){
				var that=this;
	            var param={
	                ID:that.HotelID,
	            }
	            that.getRequest({
	                url:that.Api.removeFavorite, 
	                params:param
	            }).then(res => {
	                if(res){
	                	that.isHotelCorrect=false;
	                    that.error({title:'提示',content:'取消收藏成功'});
	                }
	            });
			},
			//收藏酒店
			saveHotel(hotel){
				var that=this;
		        var param={
		            ID:that.HotelID,
		            Name:hotel.HotelName||hotel.HotelEName,
		            From:that.From,
		            ProductType:that.ProductType,
		        }
		        that.postRequest({
		            url:that.Api.addFavorite, 
		            params:param
		            }).then(res => {
			            if(res){
			            	that.isHotelCorrect=true;
			                that.error({title:'提示',content:'收藏成功'});
			            }
		        }); 
			},
			isFavoriteExist(){
	         	var that=this;
	         	if(!that.HotelID){
	         		return;

	         	}
	            var promise = new Promise(function(resolve, reject) {
		            var param={
		                id:that.HotelID,
		            }
		            that.getRequest({
		              url:that.Api.isFavoriteExist,  
		              params:param,
		              isAnonymous:true
		            }).then(res => {
		                if(res&&res==true){
		                    resolve(true);
		                }else{
		                    resolve(false);
		                }
		            }); 
	            });

	            promise.then(function(value) {
	                that.isHotelCorrect=value;
	            }, function(value) {
	               // failure
	                that.isHotelCorrect=false;
	            });
			},
			routeToMap(hotel){
				if(!hotel.Lat||!hotel.Lon){
					that.error({title:'提示',content:'该酒店没有位置信息！'});
					return;

				}

				this.$router.push(
					{ path: '/baiduMap',query:{lng:hotel.Lon,lat:hotel.Lat,m1:this.MyLon ,m2:this.MyLat,HotelName:hotel.HotelName,hotelId:this.HotelID,from:0}});
			},
			getDefaultDate(da){
				var date = new Date(da);
	            // date.setDate(date.getDate() + count); //获取count天后的日期 
	            var year = date.getFullYear();
	            var month = date.getMonth() + 1;
	            var day = date.getDate();
	       
	            var time = year + '-' + month + '-' + day;
	            return time;
			},

			openPrice:function(item,index,$event){
				
				var that=this;
				this.$nextTick(function () {
					this.$set(item,'active',item.active?false:true);
	　　　　　　	});
			},
			routeToReadme(){
				this.dao.set('mapLamndmarks',JSON.stringify(this.details.Lamndmarks));
				this.dao.set('frhotelReadmeView',JSON.stringify(this.details));
				
				this.$router.push('/frHotelView');
				
			},

			book(room,$event){
				$event.stopPropagation();

				var that=this;
				if(room.Tip>1){
					that.error({title:'不能预订',content:room.Errors});
					return;
				}

				//缓存酒店token
				var hotelToken='';
				var obj=that.details;
				//海外酒店
				
				var obj1={
					From:0,
					HotelName:obj.HotelName,
					RoomName:room.RoomName,
					RPName:room.RPName,
					AdultCount:that.AdultCount,
					ChildrenCount:that.ChildrenCount,
					ChildrenAges:that.ChildrenAges,
					CheckIn:that.CheckIn,
					CheckOut:that.CheckOut,
					Star:room.Star,
					HotelAddress:room.Address,
					HotelPhone:room.Phone,
					RoomCount:that.RoomCount,
					AdultPrice:room.Price,
					days:that.getDays(that.CheckIn,that.CheckOut),
					Token:room.Token,
					CancelPolicy:room.CancelPolicy,
					Breakfast:room.Breakfast,
					Currency:room.Currency,
					Tip:0,
					// ShareToken:that.ShareToken,
					Breakfast:room.Breakfast,
					Surcharges:room.Surcharges,
					DailyRates:room.DailyRates
				}
				hotelToken=room.Token;
				that.dao.set('bookInfo',JSON.stringify(obj1));
			
				
				//检查是否可以预订
				this.checkBookAble(hotelToken,function(){
			
					that.$router.push('/book');
				})

				
			},
			initCanvas(){
				var num =this.details.CommRate;
		        var w = document.getElementsByClassName('grade-percent')
		        var c = document.getElementById("canvas");
		        var score = document.getElementById("score");
		       	
		        score.style.marginTop ='-'+ parseInt(score.offsetHeight/2)+'px'
		        score.style.marginLeft ='-' +  parseInt(score.offsetWidth/2)+'px'
		        var ctx = c.getContext('2d');
		        var width = w[0].offsetWidth;
		        var height = w[0].offsetHeight;
		        if (window.devicePixelRatio) {
		            c.style.width = width + "px";
		            c.style.height = height + "px";
		            c.height = height * window.devicePixelRatio;
		            c.width = width * window.devicePixelRatio;
		            ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
		        }
		        var centerX = w[0].offsetWidth/2;   //Canvas中心点x轴坐标
		        var centerY = w[0].offsetHeight/2;  //Canvas中心点y轴坐标
		        var rad = Math.PI*2/100; //将360度分成100份，那么每一份就是rad度

		        drawCircle(ctx,num/5*100);
		        function drawCircle(ctx,percent){
		            //画白色的静态圆
		            ctx.save();
		            ctx.strokeStyle = "#ccc";
		            ctx.shadowColor="#fff";
		            ctx.lineWidth = 3;
		            ctx.beginPath();
		            ctx.arc(centerX, centerY, centerX-3, 0, Math.PI*2, true);
		            ctx.stroke();
		            ctx.closePath();
		            ctx.restore();

		            //画进度环
		            ctx.save();
		            ctx.strokeStyle = "#fd6e12";
		            ctx.shadowColor="#fff";
		            ctx.lineWidth = 3;
		            ctx.beginPath();
		            ctx.arc(centerX, centerY, centerX-3, -Math.PI/2, -Math.PI/2 +percent*rad, false);
		            ctx.stroke();
		            ctx.closePath();
		            ctx.restore();
		        }

		    },
			// 检查是否可以预订
			checkBookAble(token,callback){
				var that=this;
				that.$refs.cnAlert.massage='正在查询酒店库存信息，请稍候'
				that.$refs.cnAlert.isAlert=true
				var param={
					token:token
				}
				that.postRequest({
						url:that.Api.checkBookable, 
						params:param
					}).then(res => {
						that.$refs.cnAlert.massage=''
						that.$refs.cnAlert.isAlert=false
						//当IsSuccess==true时，表示有库存可以预订
					    if(res){
					    	if(res.IsSuccess){
								callback();
					    	}else{
 								this.error({title:'提示',content:res.Msg||'不能预订'});
					    	}
					    }
				});	
			},
			// 计算日期差
			getDays(s1,s2){
				s1 = new Date(s1.replace(/-/g, "/"));
				s2 = new Date(s2.replace(/-/g, "/"));

				var days = s2.getTime() - s1.getTime();
				var time = parseInt(days / (1000 * 60 * 60 * 24));
				return time;
			},
			initParam(){
				var CheckIn=this.$route.query.CheckIn||JSON.parse(this.dao.get('frHotelDetailsParams')).CheckIn;
				var CheckOut=this.$route.query.CheckOut||JSON.parse(this.dao.get('frHotelDetailsParams')).CheckOut;
				if(!CheckIn||!CheckOut)return;

				this.calendar.begin={year:CheckIn.split('-')[0],month:CheckIn.split('-')[1],day:CheckIn.split('-')[2]};
				this.calendar.end={year:CheckOut.split('-')[0],month:CheckOut.split('-')[1],day:CheckOut.split('-')[2]};
			}


		},
		mounted(){
			this.initParam();
			this.initData();
			var userInfo=this.dao.get('userInfo')?JSON.parse(this.dao.get('userInfo')):'';
			if(userInfo.CustomerNO){
				this.isFavoriteExist();
			}
			
			// console.log('ps:From===1为国内酒店，From==0为国外酒店')

		}

	}
</script>
<style>
	
</style>


// WEBPACK FOOTER //
// src/components/frHotel/details.vue